module.exports = __webpack_public_path__ + "img/image-map-3-954c1d28.png";